
import { defineComponent } from "vue";
import { mapGetters, mapMutations } from "vuex";
import common from "@/config/common";
import * as apiClient from "@/apiclient/";
import eventBus from "@/utils/eventBus";

export default defineComponent({
  name: "DocumentList",
  computed: {
    ...mapGetters([
      "getUploadProgress",
      "getUploadFiles",
      "getUploadedFiles",
      "getTotalFiles",
      "getCancelTokenSource",
      "getDocumentsUploaded",
      "getEnrollment",
    ]),
  },
  mounted() {
    this.getDocumentsList();
  },
  methods: {
    ...mapMutations([
      "setDocumentSubmitBtn",
      "setDocumentsUploaded",
      "removeUploadFile",
      "removeUploadProgress",
    ]),
    async getDocumentsList() {
      var result = null;
      var serviceType = this.getEnrollment.serviceType;

      if (serviceType == "1") {
        result = await apiClient.documentController().getApiDocument({
          customerParticipantId: this.getEnrollment.customerParticipantId,
        });
      } else {
        result = await apiClient.documentController().getApiDocument({
          customerParticipantId: this.getEnrollment.customerParticipantId,
        });
      }

      if (result?.data?.length) {
        this.setDocumentsUploaded(
          result.data.map((file: any) => {
            file.disabled = false;
            return file;
          })
        );
        this.setDocumentSubmitBtn(common.saveNext);
      } else {
        this.setDocumentsUploaded([]);
        this.setDocumentSubmitBtn(common.skipNext);
      }
    },
    async deleteDocument(electionUploadId: number) {
      const result = await apiClient.documentController().deleteApiDocument({
        electionUploadId: electionUploadId,
        customerParticipantId:
          this.getEnrollment.customerParticipantId.toString(),
      });
      if (result.data) {
        const newFiles = this.getDocumentsUploaded.filter(
          (f: { electionUploadId: number }) =>
            f.electionUploadId !== electionUploadId
        );
        this.setDocumentsUploaded(
          newFiles.map((file: any) => {
            file.disabled = false;
            return file;
          })
        );
        if (this.getDocumentsUploaded.length > 0) {
          this.setDocumentSubmitBtn(common.saveNext);
        } else {
          this.setDocumentSubmitBtn(common.skipNext);
        }

        if (this.getEnrollment.serviceType == 1) {
          eventBus.emit("refresh-document-data");
        }
      } else if (result.error) {
        const uploadedFiles = this.getDocumentsUploaded;
        this.setDocumentsUploaded(
          uploadedFiles.map((file: any) => {
            file.disabled = false;
            return file;
          })
        );
        console.error(result.error);
      }
    },
    getExtIcon(fileType: string) {
      const allFileTypes: { [key: string]: { icon: string } } = {
        "image/tiff": { icon: "tiff-icon.svg" },
        "image/bmp": { icon: "bmp-icon.svg" },
        "image/png": { icon: "png-icon.svg" },
        "image/jpeg": { icon: "jpeg-icon.svg" },
        "application/pdf": { icon: "pdf-icon.svg" },
      };

      return allFileTypes[fileType]?.icon ?? "pdf-icon.svg";
    },
    formatBytes(bytes: number, decimals = 2): string {
      if (bytes === 0) return "0B";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + "" + sizes[i];
    },
    cancelUploading(index: number) {
      this.getCancelTokenSource.cancel();
      this.removeUploadProgress(index);
      this.removeUploadFile(index);
    },
  },
});
